export default "varying vec2 vUv;\n\nvoid main() {\n\tgl_FragColor = vec4(vUv, 0.0, 1.0);\n\n}";